/**
 * The responsbility of this file is to show toast messages on specific triggers.
 * It could be used to show success, error, warning, info messages.
 */

import { toast } from 'react-toastify';
import { Body2 } from '../../themes/typography';

// export function errorToast(message) {
//     toast.error(<Body2>{message}</Body2>, { position: 'bottom-right', autoClose: 5000 });
// }

export function errorToast(message) {
    toast.error(<Body2>{message}</Body2>, { position: 'top-right', autoClose: 5000 });
}

export function successToast(message, autoClose = 5000) {
    toast.success(<Body2>{message}</Body2>, { position: 'bottom-right', autoClose: autoClose });
}

export function successToastTopRight(message, autoClose = 5000) {
    toast.success(<Body2>{message}</Body2>, { position: 'top-right', autoClose: autoClose });
}

/**
 * Caution: Dont't forget to add the ToastContainer when reuse above function in any component.
 * 
 * import { ToastContainer, Slide } from 'react-toastify';
 * <ToastContainer
        position="bottom-right"
        hideProgressBar
        draggable
        theme="colored"
        autoClose={false}
        limit={3}
        transition={Slide}
    />
 */
